import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/keyboard': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M528 64c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48h-480c-26.5 0-48-21.5-48-48v-288c0-26.5 21.5-48 48-48h480zM536 400v-288c0-4.4-3.6-8-8-8h-480c-4.4 0-8 3.6-8 8v288c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8zM170 270c0 6.6-5.4 12-12 12h-28c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h28c6.6 0 12 5.4 12 12v28zM266 270c0 6.6-5.4 12-12 12h-28c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h28c6.6 0 12 5.4 12 12v28zM362 270c0 6.6-5.4 12-12 12h-28c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h28c6.6 0 12 5.4 12 12v28zM458 270c0 6.6-5.4 12-12 12h-28c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h28c6.6 0 12 5.4 12 12v28zM122 352c0 6.6-5.4 12-12 12h-28c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h28c6.6 0 12 5.4 12 12v28zM506 352c0 6.6-5.4 12-12 12h-28c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h28c6.6 0 12 5.4 12 12v28zM122 188c0 6.6-5.4 12-12 12h-28c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h28c6.6 0 12 5.4 12 12v28zM218 188c0 6.6-5.4 12-12 12h-28c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h28c6.6 0 12 5.4 12 12v28zM314 188c0 6.6-5.4 12-12 12h-28c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h28c6.6 0 12 5.4 12 12v28zM410 188c0 6.6-5.4 12-12 12h-28c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h28c6.6 0 12 5.4 12 12v28zM506 188c0 6.6-5.4 12-12 12h-28c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h28c6.6 0 12 5.4 12 12v28zM408 346c0 6.6-5.4 12-12 12h-216c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h216c6.6 0 12 5.4 12 12v16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/keyboard.js
// module id = 1781
// module chunks = 0